import { defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";

import TagsInput from "../../vue-custom-elements/TagsInput/TagsInput.vue";
import { MessageService } from "../../../services/message-service";
import type { IGetUsersByNameQuery, IUsersList } from "../../vue-interfaces/messaging-service/i-user";
import { MeetingCalendarService } from "../../../services/meeting-calendar-service";

export default defineComponent({
    inject: ["dialogRef"],

    components: {
        TagsInput
    },

    data() {
        return {
            _messageService: null as MessageService,
            _meetingCalendarService: null as MeetingCalendarService,
            dialogReference: this.dialogRef as any,
            selectedUsers: [] as any[],
            optionalMessage: "" as string,
            conversationId: "" as string,
            shareChatHistory: false as boolean,
            isLoading: false as boolean
        };
    },

    computed: {},

    created() {
        this._messageService = Container.instance.get(MessageService);
        this._meetingCalendarService = Container.instance.get(MeetingCalendarService);
    },

    mounted() {
        this.shareChatHistory = this.dialogReference?.data?.shareChatHistory;
        this.conversationId = this.dialogReference?.data?.conversationId;
    },

    methods: {
        async getUsersList(filter: string) {
            const selectedIds = this.selectedUsers.map((user: any) => user.value || user.id);
            const query: IGetUsersByNameQuery = {
                page: 1,
                pageLength: 25,
                term: filter.trim(),
                conversationParticipantUsers: selectedIds
            };

            const data = await this._messageService.getUserByName(query);
            return this.getDisplayUsers(data.items);
        },

        getDisplayUsers(data: IUsersList[]) {
            if (data) {
                return data.map((user) => ({
                    name: `${user.lastName ? user.lastName + ", " : ""}${user.firstName}`,
                    value: user.id,
                    firstName: user.firstName,
                    lastName: user.lastName,
                    emailId: user.emailId
                }));
            }
            return [];
        },

        updateTags(value: any) {
            this.selectedUsers = value;
        },

        getUserIds(): string[] {
            return this.selectedUsers.map((user: any) => user?.value || user?.id || "").filter((id: string) => !!id);
        },

        cancel() {
            this.dialogReference.close({ status: "cancel" });
        },

        async submit() {
            try {
                const userIds = this.getUserIds();
                if (userIds.length === 0) {
                    return;
                }

                const payload = {
                    userIds,
                    conversationId: this.conversationId,
                    shareChatHistory: this.shareChatHistory
                };
                await this._meetingCalendarService.forwardMeeting(payload);
                this.dialogReference.close("success");
            } catch (error) {
                console.error("Failed to forward meeting", error);
            }
        }
    }
});
